exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".twoCols[data-v-11299950]{padding-top:var(--component-padding)}.column[data-v-11299950]{grid-column:span 6}.column[data-v-11299950]:last-child{padding-top:var(--component-padding)}img[data-v-11299950]{margin-top:auto;width:100%;aspect-ratio:1/1;-o-object-fit:cover;object-fit:cover}@media (min-width:48em) and (max-width:61.99em){.column[data-v-11299950]{grid-column:span 3}.column[data-v-11299950]:last-child{padding-top:0}}@media (min-width:62em){.column[data-v-11299950]{grid-column:span 6}.column[data-v-11299950]:last-child{padding-top:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-11299950","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/vuejs/frontend/2023-launch/components/AppTwoCols.vue
// module id = /osK
// module chunks = 4